/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import '@main';

u.$ui.bootstrap.tooltip();

const form = '#contact-form';

u.formValidation()
  .then(() => u.$ui.disableOnSubmit(form));
u.form(form).initComponent();
u.$ui.keepAlive(location.href);

// Copy
const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let buttons = $('[data-copy]');

if (mobile) {
  buttons = buttons.filter(':not([data-mobile-action])');

  $('[data-mobile-action]').attr('title', '');
}

buttons.on('click', async (e) => {
  const $btn = e.currentTarget;
  await navigator.clipboard.writeText($btn.dataset.clipboardText);
  const $tooltip = bootstrap.Tooltip.getInstance($btn);

  // @see https://github.com/twbs/bootstrap/issues/36432
  $tooltip.hide();
  $tooltip._config.title = '已複製！';

  setTimeout(() => {
    $tooltip.show();

    setTimeout(() => {
      $tooltip._config.title = '點擊複製！';
    }, 500);
  }, 300);
});

if (mobile) {
  $('[data-mobile-action]').on('click', (e) => {
    window.open($(e.currentTarget).attr('data-mobile-action'));
  });
}

// Budgets
const $budgetOptions = $('input[name="item[budget]"]');
const $budgetErrorTooltip = $('#input-item-budget-wrapper .invalid-tooltip');

$budgetOptions.on('change', (e) => {
  $budgetErrorTooltip.hide();

  $('#input-item-budget-wrapper .card').removeClass('active');

  const radio = $(e.currentTarget);
  radio.closest('.card').addClass('active');
});

// Submit
$('[data-task="submit"]').on('click', (e) => {
  const $form = document.querySelector(form);

  const validation = u.$validation.get($form);

  if (validation.validateAll()) {
    if ($budgetOptions.filter(':checked').length === 0) {
      $budgetErrorTooltip.text('請先輸入預算').show();
      $('html, body').animate({ scrollTop: $budgetErrorTooltip.offset().top - 200 });
      return;
    } else {
      $budgetErrorTooltip.hide();
    }

    $form.setAttribute('action', u.route('contact'));
    $form.requestSubmit();
  }
});
